export const AREA_MAX_VALUE = 1000;
export const AREA_MAX_VALUE = 1000;
